import * as ApiModels from '@typings/api-models';
import * as DocumentApiModels from '@/tsClient/servers/noodleDocuments/document-api-models';
import File from '@/components/DesignLibrary/File';
import CaretRight from '@components/Icons/CaretRight';

import s from './PacerDocumentRow.module.scss';

type Props = {
  onClick: () => void;
  creatorId?: string;
  compiledDocument:
    & Pick<ApiModels.UserWorkflowDocument, 'id' | 'referenceId' | 'referenceType' | 'templateReferenceType'| 'title' | 'integrationSlug' | 'integrationFileName'>
    & {
      document: Pick<DocumentApiModels.Document, 'id' | 'mimeType' | 'fileName' | 'createdAt'> | null;
    }
};

const PacerDocumentRow: React.FC<Props> = ({ compiledDocument, onClick }) => {
  const isEmpty = !compiledDocument.document;

  return (
    <>
      <div
        className={s['row-container']}
        onClick={onClick}
      >
        {compiledDocument.document && !isEmpty
          && <File document={{
            createdAt: compiledDocument.document.createdAt,
            fileName: compiledDocument.integrationFileName || compiledDocument.document.fileName,
            id: compiledDocument.document.id,
            mimeType: compiledDocument.document.mimeType,
            uploadedAt: '',
            uploadedBy: { name: null },
          }} />}
        <CaretRight size={16} />
      </div>
    </>
  );
};

export default PacerDocumentRow;